import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\DuplicateImportTaskController::__invoke
* @see app/Http/Controllers/Import/DuplicateImportTaskController.php
* @route '/api/import/{import}/task/{importTask}/duplicate'
*/
const DuplicateImportTaskController = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DuplicateImportTaskController.url(args, options),
    method: 'get',
})

DuplicateImportTaskController.definition = {
    methods: ["get","head"],
    url: '/api/import/{import}/task/{importTask}/duplicate',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Import\DuplicateImportTaskController::__invoke
* @see app/Http/Controllers/Import/DuplicateImportTaskController.php
* @route '/api/import/{import}/task/{importTask}/duplicate'
*/
DuplicateImportTaskController.url = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            import: args[0],
            importTask: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: args.import,
        importTask: typeof args.importTask === 'object'
        ? args.importTask.id
        : args.importTask,
    }

    return DuplicateImportTaskController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace('{importTask}', parsedArgs.importTask.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\DuplicateImportTaskController::__invoke
* @see app/Http/Controllers/Import/DuplicateImportTaskController.php
* @route '/api/import/{import}/task/{importTask}/duplicate'
*/
DuplicateImportTaskController.get = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DuplicateImportTaskController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Import\DuplicateImportTaskController::__invoke
* @see app/Http/Controllers/Import/DuplicateImportTaskController.php
* @route '/api/import/{import}/task/{importTask}/duplicate'
*/
DuplicateImportTaskController.head = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: DuplicateImportTaskController.url(args, options),
    method: 'head',
})

export default DuplicateImportTaskController